/**
 * Run lists: ActiveRunsPage (live + awaiting) and ConversationsPage (history).
 * `statusLabel` is the shared status-code → label map used by the history
 * filter dropdown and the row badges.
 */

import type { RunStatus } from '@portal/contracts'

export const runs = {
  // ActiveRunsPage
  activeTitle: 'Active runs',
  activeSubtitle: 'Runs in progress and anything waiting on your reply.',
  live: 'live',
  activeEmpty: 'Nothing active right now. Start a flow to see it here.',
  startedAt: (when: string) => `started ${when}`,
  needsReply: 'Needs your reply',
  running: 'running',
  answer: 'Answer',
  watch: 'Watch',

  // ConversationsPage
  historyTitle: 'History',
  historySubtitle: 'All of your past runs and conversations.',
  filterByFlow: 'Filter by flow',
  allFlows: 'All flows',
  filterByStatus: 'Filter by status',
  anyStatus: 'Any status',
  clearFilters: 'Clear filters',
  loadingHistory: 'Loading history…',
  emptyFiltered: 'No runs match these filters yet.',
  emptyNoConversations: 'No conversations yet. Launch a flow to get started.',
  emptySoFar: 'Nothing to show among the most recent runs. Load more to look further back.',
  loadMore: 'Load more',
  deliverableFilesTitle: (n: number) => `${n} deliverable file${n === 1 ? '' : 's'}`,

  // Shared status-code → label (history dropdown + row badges)
  statusLabel: (status: RunStatus): string => {
    switch (status) {
      case 'success':
        return 'Done'
      case 'partial_success':
        return 'Partial'
      case 'failure':
        return 'Failed'
      case 'awaiting_user_response':
        return 'Awaiting reply'
      default:
        return 'Running'
    }
  }
}
